import { render, staticRenderFns } from "./Vergleich.vue?vue&type=template&id=8ae1964e&"
import script from "./Vergleich.vue?vue&type=script&lang=js&"
export * from "./Vergleich.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports